const UPDATES = [
  { date: '07-29', title: '《鬼灭之刃 柱训练篇》第8话更新上线', tag: '新番更新' },
  { date: '07-29', title: '《我推的孩子 第二季》第5话中文字幕版已发布', tag: '新番更新' },
  { date: '07-28', title: '《怪兽8号》第11话高清版现已更新', tag: '新番更新' },
  { date: '07-28', title: '经典回顾专题上线：《钢之炼金术师FA》全集收录', tag: '专题上线' },
  { date: '07-27', title: '《咒术回战 第二季》第20话字幕优化版发布', tag: '字幕更新' },
  { date: '07-27', title: '七夕专题：10部最动人的恋爱动漫推荐合集', tag: '编辑推荐' },
  { date: '07-26', title: '《间谍过家家 第二季》第3话新增多字幕组版本', tag: '字幕更新' },
  { date: '07-26', title: '服务器完成升级扩容，播放稳定性大幅提升', tag: '站点公告' },
  { date: '07-25', title: '《防风少年》第12话完结篇上线，全季可完整观看', tag: '完结上线' },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">更新动态</h2>
          <p className="text-sm text-foreground-500">最新动漫资源与站点动态一览</p>
        </div>

        <div className="max-w-3xl mx-auto">
          {UPDATES.map((item, idx) => (
            <div
              key={idx}
              className="flex items-start gap-4 py-3.5 border-b border-background-200/70 last:border-0 group cursor-pointer hover:bg-background-50 transition-colors px-3 -mx-3 rounded-lg"
            >
              <span className="text-xs text-foreground-400 whitespace-nowrap pt-0.5 flex-shrink-0 w-12">
                {item.date}
              </span>
              <div className="flex-1 min-w-0">
                <span className="text-sm text-foreground-800 group-hover:text-primary-500 transition-colors">
                  {item.title}
                </span>
              </div>
              <span className="px-2 py-0.5 text-[11px] font-medium rounded-full bg-secondary-100 text-secondary-700 whitespace-nowrap flex-shrink-0">
                {item.tag}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}